import React from "react";

const Services = () => {
  const services = [
    {
      title: "Product Inspection",
      detail: "Assured product quality with our product inspection feature.",
      img: require("../../../assets/homepage/services/delivery.png"),
      bgColor: "bg-[#FFE6CD]",
    },
    {
      title: "Trade Assurance",
      detail: "Count on our trade assurance services for safe transactions.",
      img: require("../../../assets/homepage/services/announcer.png"),
      bgColor: "bg-[#FFF4DA]",
    },
    {
      title: "E-Credit Line",
      detail: "Manage expenses effortlessly with E-credit line.",
      img: require("../../../assets/homepage/services/cashback.png"),
      bgColor: "bg-[#DFFFD1]",
    },
    {
      title: "Company Branding",
      detail: "Creating your brand presence with effective company branding.",
      img: require("../../../assets/homepage/services/announcer.png"),
      bgColor: "bg-[#D8F3FF]",
    },
    {
      title: "Digitalize Logistics Support",
      detail:
        "Go digital for better logistics management with Digitalize Logistics Support",
      img: require("../../../assets/homepage/services/location.png"),
      bgColor: "bg-[#FFE7E7]",
    },
    {
      title: "Smooth Operations",
      detail:
        "Ensures operations run smoothly and hassle - free with Smooth Operations",
      img: require("../../../assets/homepage/services/setting.png"),
      bgColor: "bg-[#DFF0FF]",
    },
    {
      title: "Nationwide Access",
      detail:
        "Experience seamless connectivity nationwide with nationwide access.",
      img: require("../../../assets/homepage/services/IndiaMap.png"),
      bgColor: "bg-[#FFE4D1]",
    },
    {
      title: "Full Stack Digital Platform",
      detail:
        "Access a complete suite of digital tools with Full Stack Digital Platform",
      img: require("../../../assets/homepage/services/announcer.png"),
      bgColor: "bg-[#E2D8FF]",
    },
  ];

  return (
    <div className="lg:max-w-[1241px] max-w-auto mx-auto mt-[20px] md:mt-[16px] lg:mt-[50px] px-4 lg:px-0 md:flex md:flex-col md:items-center">
      <div className="flex items-center justify-center w-full md:w-[696px] md:h-[24px] lg:w-full">
        <hr className="hidden md:block bg-[#FF8100] w-[50px] sm:w-[100px] md:w-[124px] lg:w-[292px] h-[4px] rounded-full" />
        <h2 className="text-[14px] sm:text-[20px] md:text-[16px] md:font-semibold font-semibold text-center mx-2 sm:mx-4 w-[257px] h-[42px] md:w-[411px] md:h-[24px] select-none lg:w-[616px] lg:h-[36px] lg:font-semibold lg:text-[24px]">
          Enhance your trading experience with our services
        </h2>
        <hr className="hidden md:block bg-[#FF8100] w-[50px] sm:w-[100px] md:w-[124px] lg:w-[292px] h-[4px] rounded-full mt-[5px]" />
      </div>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-x-4 md:gap-x-[64px] lg:gap-x-[49px] lg:gap-y-[97px] gap-y-[55px] md:gap-y-[69px] mt-[56px] md:mt-[49px] md:item-center md:justify-center md:flex md:flex-wrap lg:mt-[80px]">
        {services.map((item, index) => (
          <div
            key={index}
            className="flex flex-col justify-start md:justify-center items-center relative w-[154px] h-[185px] drop-shadow-[0_0px_3px_rgba(0,0,0,0.10)] bg-white rounded-xl md:rounded-[10px] md:w-[195px] md:h-[203px] lg:w-[273px] lg:h-[285px] select-none"
          >
            <div className=" sm:px-8 pt-[64px] px-[10px] md:pt-[67px] md:px-[9px] md:pb-[32px] lg:px-[13px]">
              <div
                className={`${item.bgColor} absolute md:flex w-[66px] h-[66px] md:items-center md:justify-center top-[-38px] left-1/2 transform -translate-x-1/2 p-3 rounded-full md:w-[64px] md:h-[64px] lg:w-[103px] lg:h-[103px] flex items-center justify-center`}
              >
                <img
                  className="h-auto w-auto sm:h-[55px] md:h-auto md:w-auto lg:h-[65px]"
                  src={item.img}
                  alt={item.title}
                />
              </div>
              <h4 className="text-[14px] lg:font-semibold lg:text-[18px] lg:h-[30px] lg:mb-[19px] sm:text-[17px] md:text-[16px] md:font-semibold text-center font-semibold mb-[8px] md:mb-[8px]">
                {item.title}
              </h4>
              <p className="text-[#979797] w-[133px] h-[51px] font-semibold md:w-[177px] md:h-[96px] text-[10px] sm:text-[15px] text-center md:font-semibold md:text-[14px] lg:h-[78px] lg:w-[231px] lg:font-semibold lg:text-[15px]">
                {item.detail}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Services;
